import React, { useState, useEffect } from 'react';
import { faSearch, faEdit, faFileAlt, faCheck, faFilePdf } from '@fortawesome/free-solid-svg-icons';

//Components
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

import { getSessionCookie } from "../../../../helpers/cookies.js";

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

// Contexts
import { useAuth } from 'context/auth';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TabelaEnderecos({
    enderecos = [],
    editarEndereco = null,
    removerEndereco = null,
    paging = true,
    ficha,
    integracaoCadastros,
    analiseLocalidade = null,
    visualizarAnaliseLocalidade = null,
    handleOpenModalPGRSEndereco
}) {
    const session = getSessionCookie();

    const { setupVariavel } = useAuth();


    const renderCustom = (rowData, index, field) => {
        const tooltipId = `tooltip-${index}-${field}`;
        if (!session || session.acesso.modulo == "Gestor") {
            return (
                <span className='position-relative'>
                    <span data-bs-toggle="tooltip" data-bs-placement="top" title={rowData.hash} id={tooltipId}>
                        {rowData[field]}
                    </span>
                </span>
            );
        }
        else if (!session || session.acesso.modulo == "Gerador" && rowData.status == "Reprovado") {
            return (
                <span class="badge bg-danger">
                    {field == "reprova" ? <Button onClick={() => { visualizarAnaliseLocalidade(rowData.id) }} color="bg-gradient bg-danger text-light" style={{ width: "20px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", color: "white" }} ><FontAwesomeIcon icon={faSearch} /></Button> : null}
                    {rowData[field]}
                </span>
            )
        }
        else {
            return (<span> {rowData[field]}</span>)
        }
    };


    //Cabeçalhos da tabela de endereços
    const headersTabelaEnderecos = [
        { value: "Código Localidade", objectValue: "codigoLocalidade", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'codigoLocalidade') },
        { value: "Código Sistema de Cadastro", objectValue: "idExterno", align: "left", customBodyRenderLite: (rowData, index) => renderCustom({ ...rowData, idExterno: rowData.idExterno ? String(rowData.idExterno).padStart(8, "0") : "" }, index, 'idExterno') },
        { value: "CEP", objectValue: "cep", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'cep') },
        { value: "UF", objectValue: "uf", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'uf') },
        { value: "Cidade", objectValue: "cidade", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'cidade') },
        { value: "Bairro", objectValue: "bairro", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'bairro') },
        { value: "Logradouro", objectValue: "logradouro", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'logradouro') },
        { value: "Número", objectValue: "numero", align: "right", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'numero') },
        { value: "Complemento", objectValue: "complemento", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'complemento') },
        { value: "Regional", objectValue: "tbSetores_Descricao", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'tbSetores_Descricao') },
        { value: "Status", objectValue: "status", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'status') },
        ...((session?.acesso?.modulo == "Gerador" && setupVariavel?.requerAnaliseGeradorLocalidade) ? [{ value: "Motivo Reprova", objectValue: " ", align: "left", customBodyRenderLite: (rowData, index) => renderCustom(rowData, index, 'reprova') }] : [])
    ];


    const editarFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser editados na tabela
        if (session?.acesso?.sigla !== 'GS' && (integracaoCadastros || (setupVariavel?.quemCadastraContrato == "Gerador" && session?.acesso?.sigla !== "GG")))
            rowData.editEndereco = false;

        if (rowData.editEndereco) {
            return actionsTable.editar(() => editarEndereco(rowData));
        } else {
            return null;
        }
    }
    const removerEnderecoFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser editados na tabela
        if (integracaoCadastros || (setupVariavel?.quemCadastraContrato == "Gerador" && session?.acesso?.sigla !== "GG"))
            rowData.removeEndereco = false;

        if (rowData.removeEndereco) {
            return actionsTable.remover(() => removerEndereco(rowData));
        } else {
            return null;
        }
    }
    const aprovarLocalidadeFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser aprovados na tabela
        if (analiseLocalidade) {
            return actionsTable.aprovar(() => analiseLocalidade({ ...rowData, status: "Ativo" }));
        } else {
            return null;
        }
    }
    const reprovarLocalidadeFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser reprovados na tabela
        if (analiseLocalidade) {
            return actionsTable.reprovar(() => analiseLocalidade({ ...rowData, status: "Reprovado" }));
        } else {
            return null;
        }
    }

    const visualizarLocalidadeFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser visualizados na tabela
        if (analiseLocalidade || (session?.acesso?.modulo == "Gerador" && setupVariavel?.requerAnaliseGeradorLocalidade && rowData.status == "Reprovado")) {
            return actionsTable.visualizar(() => visualizarAnaliseLocalidade(rowData.id));
        } else {
            return null;
        }
    }

    const openModalPGRSFunction = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser visualizados na tabela
        if (
            analiseLocalidade ||
            (
                session?.acesso?.modulo == "Gestor" &&
                setupVariavel?.requerAnaliseGeradorLocalidade &&
                rowData?.contratosLocalidadePGRS?.length > 0
            )
        ) {
            return actionsTable.ficha(() => handleOpenModalPGRSEndereco(rowData.id), "Visualizar PGRS");
        } else {
            return null;
        }
    }

    let actions = []
    if (analiseLocalidade && session?.acesso?.modulo == "Gestor" && (setupVariavel?.requerAnaliseGeradorLocalidade || setupVariavel?.informarCnaeCadastroGerador)) {
        actions = [visualizarLocalidadeFunction, aprovarLocalidadeFunction, reprovarLocalidadeFunction, openModalPGRSFunction]
    }
    else if (session?.acesso?.modulo == "Gerador" && setupVariavel?.requerAnaliseGeradorLocalidade) {
        actions = [visualizarLocalidadeFunction, editarFunction, removerEnderecoFunction];
    }
    else {
        actions = [editarFunction, removerEnderecoFunction];
    }

    if (!ficha)
        return <TabelaListagem
            actions={actions}
            title={"Lista de endereços"}
            headers={headersTabelaEnderecos}
            items={enderecos}
            options={{ print: false, search: true, pagination: paging }}
        />

    return <TabelaListagemFichas
        headers={headersTabelaEnderecos}
        items={enderecos}
        paging={paging}
    />
}